import { useState } from 'react';

import { CertificateVisibility, EnergyPlan } from '../../../../../types/building';
import { useGrantCertificateConsent } from '../../../../../components/certificateVisibilityConsentDialog/useGrantCertificateConsent';
import { useRevokeCertificateConsent } from '../../../../../components/certificateVisibilityConsentDialog/useRevokeCertificateConsent';

interface UseSamtykkeSubmitProps {
  registreringId: string;
  energiplan: EnergyPlan;
}

export const useSamtykkeSubmit = ({ registreringId, energiplan }: UseSamtykkeSubmitProps) => {
  const [certificateVisibility, setCertificateVisibility] = useState<CertificateVisibility | undefined>();
  const [showError, setShowError] = useState(false);

  const { grantCertificateConsentAsync, isLoading: isGrantLoading } = useGrantCertificateConsent(registreringId);
  const { revokeCertificateConsentAsync, isLoading: isRevokeLoading } = useRevokeCertificateConsent(registreringId);

  const onSamtykkeSubmit = async (visbility: CertificateVisibility) => {
    if (!visbility) {
      setShowError(true);
      return false;
    }

    setShowError(false);

    if (visbility === 'offentlig') {
      await grantCertificateConsentAsync(energiplan.energiplanId);
    } else if (visbility === 'reservert') {
      await revokeCertificateConsentAsync(energiplan.energiplanId);
    }

    return true;
  };

  const handleVisibilityChange = (visibility: CertificateVisibility) => {
    setCertificateVisibility(visibility);
    setShowError(false);
  };

  return {
    certificateVisibility,
    setCertificateVisibility: handleVisibilityChange,
    onSamtykkeSubmit,
    isLoading: isGrantLoading || isRevokeLoading,
    showError
  };
};
